module.exports = __webpack_public_path__ + "media/bootstrap-icons/tag-1b81498e.svg";